import { render, staticRenderFns } from "./Landing.vue?vue&type=template&id=3015f9e0&scoped=true&"
import script from "./Landing.vue?vue&type=script&lang=js&"
export * from "./Landing.vue?vue&type=script&lang=js&"
import style0 from "./style.scss?vue&type=style&index=0&id=3015f9e0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3015f9e0",
  null
  
)

export default component.exports